import React from "react";
import "./ConfirmacaoUsuario.css";
import { Link } from "react-router-dom";
import { AuthShell } from "../../../components/AuthShell";
import { FiCheckCircle } from "react-icons/fi";

const ConfirmacaoUsuario = () => {
    return (
        <AuthShell
            eyebrow="Cadastro"
            title="Conta recebida"
            subtitle="A equipe Omex Capital vai analisar as informações enviadas antes da liberação final de acesso."
        >
            <section className="auth-card cliente-confirmation-card">
                <div className="cliente-confirmation-icon success">
                    <FiCheckCircle />
                </div>
                <h2>Informações recebidas</h2>
                <p>Entraremos em contato após a análise dos documentos.</p>
                <Link className="auth-primary-button confirmacao-usuario-link" to="/">
                    Voltar ao login
                </Link>
            </section>
        </AuthShell>
    );
};

export default ConfirmacaoUsuario;
